import { Injectable } from '@angular/core';
import { createStore, setProp, withProps } from '@ngneat/elf';

import { formatToDateParsableString } from '@VineyardLib/utils/format-strings';

interface BizDateProps {
  bizDate: string; // yyyyMMdd
}

const bizDateStore = createStore(
  { name: 'bizDate' },
  withProps<BizDateProps>({ bizDate: '' })
);

@Injectable({ providedIn: 'root' })
export class BizDateRepository {
  get string(): string {
    return bizDateStore.getValue().bizDate;
  }

  get date(): Date {
    return new Date(formatToDateParsableString(this.string));
  }

  set data(value: string) {
    bizDateStore.update(setProp('bizDate', value));
  }
}
